module.exports = __webpack_public_path__ + "img/vg.b142c100.svg";